// extracted by mini-css-extract-plugin
module.exports = {"ttsBtn":"index-module_ttsBtn_3m1xk","ttsIcon":"index-module_ttsIcon_34hrx","active":"index-module_active_6qVhg"};